import { render } from "./instructor-withdraw.vue?vue&type=template&id=5dabe3a8"
import script from "./instructor-withdraw.vue?vue&type=script&lang=js"
export * from "./instructor-withdraw.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__